import React, { Component } from "react";
import WallStores from "./WallStores";

class WallRight extends Component {
  render() {
    return (
      <React.Fragment>
        <WallStores />
      </React.Fragment>
    );
  }
}

export default WallRight;
